import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgParcelMid = function SvgParcelMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9379 16.2576C12.9379 15.9044 13.2242 15.6182 13.5773 15.6182H16.7319C17.085 15.6182 17.3713 15.9044 17.3713 16.2576C17.3713 16.6107 17.085 16.897 16.7319 16.897H13.5773C13.2242 16.897 12.9379 16.6107 12.9379 16.2576Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18.1332V9.12435C20 8.86878 19.95 8.62489 19.8593 8.4019C19.8637 8.3113 19.8488 8.21833 19.8122 8.12885L18.1298 4.02165L18.1224 4.00442C17.8506 3.39269 17.2436 2.99888 16.5743 3H7.42682C6.75717 2.99852 6.14968 3.39239 5.87778 4.00443L5.87043 4.02165L4.18801 8.12885C4.15141 8.2182 4.13651 8.31103 4.14086 8.4015C4.05004 8.62459 4 8.86863 4 9.12435V18.1332C4 19.1927 4.85885 20.0515 5.91829 20.0515H18.0817C19.1411 20.0515 20 19.1927 20 18.1332ZM5.9183 8.48492C5.56515 8.48492 5.27886 8.7712 5.27886 9.12435V18.1332C5.27886 18.4864 5.56515 18.7727 5.91829 18.7727H18.0817C18.4349 18.7727 18.7211 18.4864 18.7211 18.1332V9.12435C18.7211 8.7712 18.4349 8.48492 18.0817 8.48492H5.9183ZM16.9507 4.51705C16.883 4.37169 16.737 4.27852 16.5762 4.27887L16.5749 4.27887H12.6394V7.20605H18.0522L16.9507 4.51705ZM7.42602 4.27887L7.42424 4.27887C7.26336 4.27842 7.11717 4.3716 7.04949 4.51707L5.94801 7.20605H11.3605V4.27887H7.42602Z"
  })));
};

export { SvgParcelMid as ReactComponent };
//# sourceMappingURL=parcel-mid.svg.js.map
